import { useTranslation } from "react-i18next";

import { Icon, IconProps } from "@/lib/components/ui/Icon/Icon";
import { LoaderIcon } from "@/lib/components/ui/LoaderIcon/LoaderIcon";
import Tooltip from "@/lib/components/ui/Tooltip/Tooltip";
import { THREAD_STATUS_LABEL_KEYS, ThreadStatus } from "@/lib/types/Thread";

import styles from "./ThreadStatusIcon.module.scss";

type StatusConfig = Pick<IconProps, "name">;

const STATUS_CONFIG: Record<ThreadStatus, StatusConfig> = {
  [ThreadStatus.InProgress]: {
    name: "loader",
  },
  [ThreadStatus.Error]: {
    name: "warning",
  },
  [ThreadStatus.Ready]: {
    name: "check",
  },
  [ThreadStatus.InputRequired]: {
    name: "info",
  },
  [ThreadStatus.Completed]: {
    name: "checkCircle",
  },
  [ThreadStatus.Cancelled]: {
    name: "close",
  },
};

type ThreadStatusIconProps = {
  status: ThreadStatus | null;
  animated?: boolean;
};

export const ThreadStatusIcon = ({
  status,
  animated = false,
}: ThreadStatusIconProps): JSX.Element | null => {
  const { t } = useTranslation("translation");

  if (!status) return null;

  const config = STATUS_CONFIG[status];

  return (
    <Tooltip tooltip={t(THREAD_STATUS_LABEL_KEYS[status])} small>
      <span
        className={`${styles.status_icon} ${styles[status]}`}
        data-test={`thread-status-icon-${status}`}
      >
        {animated && status === ThreadStatus.InProgress ? (
          <LoaderIcon size="small" color="inherit" />
        ) : (
          <Icon name={config.name} size="small" color="inherit" />
        )}
      </span>
    </Tooltip>
  );
};
